import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';

export default function fetchSkills() {
  return useApi(http.get('/content/skills'));
}
